import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"
import { useEffect, useRef, useState } from "preact/hooks";

export default () => {
    const { query, response: { products } } = useAppState();
    const [ swatchData, setSwatchData ] = useState([]);
    const lastQueryRef = useRef(undefined);

    useEffect(() => {
        if(!products?.hits || products.hits?.length < 1) return;

        const fetchGroups = async (globalNameValue) => {
            try {
                const res = await fetch('https://api.nosto.com/v1/graphql', {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/graphql',
                        'Authorization': 'Basic ' + btoa(":" + "vVCSd8Ul0r7HdWq5pXawNZCrflkGfjUxu13YXzzy6oqhuT1M92pktQYBKT1BULUa")
                    }),
                    mode: 'cors',
                    body: `
                    query {
                        products(limit: 700, filter: { customFields: { attribute: "custom-color_swatch_group", values: ${JSON.stringify(globalNameValue)} } }) {
                            products {
                                productId
                                listPrice
                                price
                                name
                                imageUrl
                                thumbUrl
                                availability
                                alternateImageUrls
                                url
                                tags1
                                skus {
                                    id
                                }
                                attributes {
                                    key
                                    value
                                }
                            }
                        }
                    }
                `
                });
                const data = await res.json();
                return data;
            } catch (err) {
                return console.error(err);
            }
        };

        const isNewQuery = query?.query && query.query !== lastQueryRef?.current;
        if(isNewQuery) { 
            lastQueryRef.current = query.query;
        }

        // determine new product groups to query
        const groupsToFetch = [];
        const swatchDataToKeep = [];
        products.hits.forEach(product => {
            const groupTag = product?.customFields?.find(field => field.key === 'custom-color_swatch_group')?.value;
            const groupInData = swatchData.find(group => group.groupId === groupTag);
            if(groupTag && !groupInData && !groupsToFetch.includes(groupTag)) {
                groupsToFetch.push(groupTag);
            } else if (isNewQuery && groupInData) {
                swatchDataToKeep.push(groupInData);
            }
        });

        if(groupsToFetch?.length < 1) return // no NEW groups: skip query

        fetchGroups(groupsToFetch)
            .then(data => {
                // console.log("data", data);
                const groupProducts = data?.data?.products?.products.filter(product => product.availability !== 'Invisible').filter(product => product.availability !== 'Discontinued');
                if(!groupProducts || groupProducts?.length < 1) return;
                const updatedSwatchData = (isNewQuery) ? swatchDataToKeep : [...swatchData];
                groupsToFetch.forEach(groupTag => {
                    const swatchProducts = groupProducts.filter(product => product.attributes.find(field => field.key === 'custom-color_swatch_group')?.value == groupTag);
                    const swatchGroup = { groupId: groupTag, products: swatchProducts };
                    updatedSwatchData.push(swatchGroup);
                });
                setSwatchData(updatedSwatchData);
            });
        }, [ products, query?.query ]);

    return {
        swatchData,
    }
}
